module.exports = __webpack_public_path__ + "static/media/ic_facepay.ffcd1a76.svg";